// extracted by mini-css-extract-plugin
module.exports = {"root":"UpcomingEventsSection-module--root--1Ku4M","noEventsText":"UpcomingEventsSection-module--noEventsText--1hjtN","noEvents":"UpcomingEventsSection-module--noEvents--14OfJ"};